export default __webpack_public_path__ + "static/media/Janod-tap-tap-xylophone-wood.ddd95128.jpg";